<template>
  <div>
    <div class="d-flex justify-content-between p-3 p-sm-0 mb-3">
      <h1 class="mb-0 header-main text-uppercase d-inline">SETTING</h1>
      <button class="create-button">
        <div>
          <font-awesome-icon icon="plus-square" />
          <span class="ml-2"> CREATE</span>
        </div>
      </button>
    </div>
    <div class="bg-white-border p-3 text-black">
      <b-tabs content-class="mt-3">
        <!-- <b-tab title="Appearence"><p>I'm the first tab</p></b-tab>
        <b-tab title="Chatbot"><p>I'm the second tab</p></b-tab>
        <b-tab title="Logging"><p>I'm the second tab</p></b-tab> -->
        <b-tab title="Facebook Live" active>
          <ConnectFacebook />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import ConnectFacebook from "./components/Connect.vue";
export default {
  components: {
    ConnectFacebook,
  },
};
</script>

<style>
.create-button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  background-color: #5b57a5;
  color: #ffffff !important;
  border-radius: 4px;
  border: none;
}
</style>
